import React, { useEffect, useRef, useState } from 'react';
import { MessageCircle, ChevronDown } from 'lucide-react';

const waPhone = (raw) => {
  if (!raw) return null;
  let d = String(raw).replace(/\D/g, '');
  if (!d) return null;
  if (d.startsWith('00')) d = d.slice(2);
  if (d.startsWith('0')) d = '972' + d.slice(1);
  return d;
};

const TEMPLATES = [
  { id: 'en', label: 'English', build: (n, a) => `Hello ${n}, this is a friendly reminder from Gerizim Customs Clearance. Your remaining balance is ₪${a}. Thank you! 🙏` },
  { id: 'ar', label: 'العربية', build: (n, a) => `مرحباً ${n}، تحية طيبة من جيريزيم للتخليص الجمركي. نودّ تذكيركم بأن الرصيد المتبقي عليكم هو ₪${a}. شكراً لكم 🙏` },
  { id: 'he', label: 'עברית', build: (n, a) => `שלום ${n}, תזכורת ידידותית מגריזים עמילות מכס. היתרה שנותרה לתשלום היא ₪${a}. תודה רבה 🙏` },
];

export const WhatsAppReminder = ({ name, phone, remaining, compact = false }) => {
  const [open, setOpen] = useState(false);
  const ref = useRef(null);
  const p = waPhone(phone);
  const amount = (Number(remaining) || 0).toLocaleString(undefined, { maximumFractionDigits: 0 });

  useEffect(() => {
    const onDoc = (e) => { if (ref.current && !ref.current.contains(e.target)) setOpen(false); };
    document.addEventListener('mousedown', onDoc);
    return () => document.removeEventListener('mousedown', onDoc);
  }, []);

  const send = (e, t) => {
    e.stopPropagation();
    window.open(`https://wa.me/${p}?text=${encodeURIComponent(t.build(name, amount))}`, '_blank', 'noopener');
    setOpen(false);
  };

  if (!p) return null;

  return (
    <div ref={ref} className="relative inline-block" onClick={(e) => e.stopPropagation()}>
      {compact ? (
        <button
          onClick={(e) => { e.stopPropagation(); setOpen((o) => !o); }}
          className="w-7 h-7 rounded-full flex items-center justify-center transition-transform hover:scale-110"
          style={{ background: '#25D366', color: '#FFFFFF', boxShadow: '0 4px 12px -4px rgba(37,211,102,0.6)' }}
          title="Send WhatsApp payment reminder"
          data-testid="whatsapp-reminder-btn"
        >
          <MessageCircle size={14} />
        </button>
      ) : (
        <button
          onClick={(e) => { e.stopPropagation(); setOpen((o) => !o); }}
          className="flex items-center gap-2 px-4 h-10 rounded-full text-[13px] font-semibold transition-transform hover:scale-[1.02]"
          style={{ background: '#25D366', color: '#FFFFFF', boxShadow: '0 6px 16px -6px rgba(37,211,102,0.6)' }}
          data-testid="whatsapp-reminder-btn"
        >
          <MessageCircle size={15} /> Remind on WhatsApp <ChevronDown size={13} />
        </button>
      )}
      {open && (
        <div
          className="absolute end-0 mt-2 z-50 rounded-2xl overflow-hidden py-1"
          style={{ background: 'var(--gg-card-solid)', border: '1px solid var(--gg-border)', boxShadow: '0 16px 40px -12px rgba(0,0,0,0.35)', minWidth: 170 }}
          data-testid="whatsapp-lang-menu"
        >
          <p className="px-3 pt-2 pb-1 gg-eyebrow" style={{ fontSize: 9 }}>Message language</p>
          {TEMPLATES.map((t) => (
            <button
              key={t.id}
              onClick={(e) => send(e, t)}
              className="w-full text-start px-3 py-2 text-sm font-medium transition-colors hover:opacity-80"
              style={{ color: 'var(--gg-text)' }}
              data-testid={`whatsapp-lang-${t.id}`}
            >
              {t.label}
            </button>
          ))}
        </div>
      )}
    </div>
  );
};
